import axios from 'axios'
import { showSuccess, showError } from '../../index.js'
export default {
  namespaced: true,
  state () {
    return {
      menus: [],
      subMenus: [],
      blankMenuData: {
        id: 0,
        name: '',
        url: ''
      },
      blankSubMenuData: {
        id: 0,
        name: ''
      }
    }
  },
  getters: {
    // const lang = rootState.lang === 'vn' ? 'vn' : 'en';
    // backend
    backendMenus (state) {
      return state.menus.slice().reverse().filter(item => item.lang === 'vn')
    },
    backendSubMenus (state) {
      return state.subMenus.slice().reverse().filter(item => item.lang === 'vn')
    },
    vnBackendMenusTab: (state) => (url) => {
      const data = state.menus.find(item => item.url === url && item.lang === 'vn')
      if (!data) {
        return state.blankMenuData
      }
      return data
    },
    enBackendMenusTab: (state) => (url) => {
      const data = state.menus.find(item => item.url === url && item.lang === 'en')
      if (!data) {
        return state.blankMenuData
      }
      return data
    },
    vnBackendSubMenusTab: (state) => (url) => {
      const data = state.subMenus.find(item => item.url === url && item.lang === 'vn')
      if (!data) {
        return state.blankSubMenuData
      }
      return data
    },
    enBackendSubMenusTab: (state) => (url) => {
      const data = state.subMenus.find(item => item.url === url && item.lang === 'en')
      if (!data) {
        return state.blankSubMenuData
      }
      return data
    },
    selectMenuForSub: (state) => (lang) => {
      const data = state.menus
        .filter(item => item.lang === lang && item.hasDropDown === true)
        .map(item => ({ id: item.id, name: item.name, menuUrl: item.url }))
      return data
    },
    showNavForTrainingService: (state) => (id) => {
      const data = state.subMenus
        .find(item => item.id === id)
      if (!data) return ''
      return data.name
    },
    selectSubForTrainingService: (state) => (lang) => {
      if (lang === 'vn') {
        const data = state.subMenus
          .filter(item => item.lang === lang && item.menuId === 3)
          .map(item => ({ id: item.id, name: item.name, tsurl: item.url }))
        return data
      } else {
        const data = state.subMenus
          .filter(item => item.lang === lang && item.menuId === 10)
          .map(item => ({ id: item.id, name: item.name, tsurl: item.url }))
        return data
      }
    },
    getMenuIdForOtherLang: (state) => (url) => {
      return state.menus.filter(item => item.hasDropDown === true && item.url === url)
    },
    // front
    menuNavbar (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.menus.filter(item => item.lang === 'vn' && item.isHidden === false).sort((a, b) => a.numOrder - b.numOrder)
      } else {
        return state.menus.filter(item => item.lang === 'en' && item.isHidden === false).sort((a, b) => a.numOrder - b.numOrder)
      }
    },
    finalMenu (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.menus.filter(item => item.lang === 'vn' && item.isHidden === false)
      } else {
        return state.menus.filter(item => item.lang === 'en' && item.isHidden === false)
      }
    },
    finalSubMenus1: (state, getters, rootState) => (id) => {
      if (rootState.lang === 'vn') {
        const data = state.subMenus.filter(item => item.lang === 'vn' && item.isHidden === false)
        return data.filter(item => item.menuId === id).sort((a, b) => a.numOrder - b.numOrder)
      } else {
        const data = state.subMenus.filter(item => item.lang === 'en' && item.isHidden === false)
        return data.filter(item => item.menuId === id).sort((a, b) => a.numOrder - b.numOrder)
      }
    },
    finalSubMenusFooter: (state, getters, rootState) => (id) => {
      const subMenusFooter = [...state.subMenus]

      const noSubMenu = state.menus.filter(x => x.hasDropDown === false && x.isHidden === false)

      if (noSubMenu.length > 0) {
        noSubMenu.forEach(menu => {
          subMenusFooter.push({
            menuId: menu.id,
            name: menu.name,
            lang: menu.lang,
            url: menu.url,
            isHidden: menu.isHidden
          })
        })
      }

      if (rootState.lang === 'vn') {
        const data = subMenusFooter.filter(item => item.lang === 'vn' && item.isHidden === false)
        return data.filter(item => item.menuId === id).sort((a, b) => a.numOrder - b.numOrder)
      } else {
        const data = subMenusFooter.filter(item => item.lang === 'en' && item.isHidden === false)
        return data.filter(item => item.menuId === id).sort((a, b) => a.numOrder - b.numOrder)
      }
    },
    findSubMenus1: (state, getters, rootState) => (id) => {
      return state.subMenus.find(item => item.id === id)
    },
    findMenuNameByUrl: (state, getters, rootState) => (url) => {
      const data = state.menus.find(item => item.url === url && item.lang === rootState.lang)
      if (!data) return ''
      return data.name
    },
    findSubMenuNameByUrl: (state, getters, rootState) => (url) => {
      const data = state.subMenus.find(item => item.url.includes(url) && item.lang === rootState.lang)
      if (!data) return ''
      return data
    },
    getMenuName: (state, getters, rootState) => (id) => {
      const data = state.menus.find(item => item.id === id && item.lang === rootState.lang)
      if (!data) return ''
      return data.name
    }
  },
  mutations: {
    setMenus (state, payload) {
      state.menus = payload
    },
    setSubMenus (state, payload) {
      state.subMenus = payload
    }
  },
  actions: {
    async getMenuData (context) {
      await axios.get(context.rootState.API_Url + 'Menus/').then((response) => {
        const responseData = response.data
        context.commit('setMenus', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async getMenuAdminData (context) {
      await context.rootState.authAxios.get('/Menus/GetMenuAdmin').then((response) => {
        const responseData = response.data
        context.commit('setMenus', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async postMenu (context, payload) {
      await context.rootState.authAxios.post('/Menus/', {
        name: payload.name,
        url: payload.url,
        hasDropDown: payload.hasDropDown,
        isHidden: payload.isHidden,
        lang: payload.lang,
        numOrder: payload.numOrder,
        type: payload.type
      })
    },
    async updateMenu (context, payload) {
      await context.rootState.authAxios.put(`/Menus/${payload.id}`, {
        name: payload.name,
        url: payload.url,
        hasDropDown: payload.hasDropDown,
        isHidden: payload.isHidden,
        lang: payload.lang,
        numOrder: payload.numOrder,
        type: payload.type
      })
    },
    async deleteMenu (context, payload) {
      await context.rootState.authAxios.delete(`/Menus/${payload}`
      ).then(() => {
        showSuccess('Xóa thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    // subMenus
    async getSubMenuData (context) {
      await axios.get(context.rootState.API_Url + 'SubMenus/').then((response) => {
        const responseData = response.data
        context.commit('setSubMenus', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async getSubMenuAdminData (context) {
      await context.rootState.authAxios.get('/SubMenus/GetSubMenuAdmin').then((response) => {
        const responseData = response.data
        context.commit('setSubMenus', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async postSubMenu (context, payload) {
      console.log(payload)
      await context.rootState.authAxios.post('/SubMenus/', {
        name: payload.name,
        url: payload.url,
        menuId: payload.menuId,
        hasSubMenu: payload.hasSubMenu,
        isHidden: payload.isHidden,
        lang: payload.lang,
        numOrder: payload.numOrder,
        type: payload.type
      })
    },
    async updateSubMenu (context, payload) {
      await context.rootState.authAxios.put(`/SubMenus/${payload.id}`, {
        name: payload.name,
        url: payload.url,
        menuId: payload.menuId,
        hasSubMenu: payload.hasSubMenu,
        isHidden: payload.isHidden,
        lang: payload.lang,
        numOrder: payload.numOrder,
        type: payload.type
      })
    },
    async deleteSubMenu (context, payload) {
      await context.rootState.authAxios.delete(`/SubMenus/${payload}`
      ).then(() => {
        showSuccess('Xóa thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    }
  }
}
